import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setReducerState, createInitialStatePart } from '../utils/reduxUtils';
// import { SliceCaseReducers } from "@reduxjs/toolkit/src/createSlice"

import { LoadProfileAction, UpdateProfileAction } from '../actionTypes/profile';
import { FullProfileState, ProfileInitialState } from '../models/profile';
import { ListResponse } from '../models/common';
import { RootState } from '../store';


const STATE_KEY = 'profile';
const initialState = {
  ...createInitialStatePart('profile'),
};

// const profile = createSlice<ProfileInitialState, SliceCaseReducers<ProfileInitialState>, 'profile'>({
const profile = createSlice({
  name: STATE_KEY,
  initialState: initialState as ProfileInitialState,
  reducers: {
    loadProfile: (state, action: PayloadAction<LoadProfileAction>) => {
      return setReducerState('loading', 'profile', { state, action });
    },
    loadProfileSuccess: (state, action: PayloadAction<ListResponse<FullProfileState>>) => {
      return setReducerState('loaded', 'profile', { state, data: action.payload });
    },
    loadProfileFail: (state, action) => {
      return setReducerState('error', 'profile', { state, error: action.payload });
    },
    updateProfile: (state, action: PayloadAction<UpdateProfileAction>) => {
      return setReducerState('loading', 'profile', { state, action });
    },
    updateProfileSuccess: (state, action: PayloadAction<ListResponse<FullProfileState>>) => {
      return setReducerState('loaded', 'profile', { state, data: action.payload });
    },
    updateProfileFail: (state, action) => {
      return setReducerState('error', 'profile', { state, error: action.payload });
    },
  },
});

//Selectors
export const profileData = (state: RootState) => state.profile.profile.data;

//Actions
export const profileActions = profile.actions;

//Reducers
export default profile.reducer;
